"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Animate = _ref => {
  let {
    show,
    children,
    from,
    to,
    exitAnimation,
    options = {
      duration: 500,
      fill: "forwards"
    },
    className
  } = _ref;
  const containerRef = (0, _react.useRef)(null);
  const preferReducedMotion = (0, _hooks.usePrefersReducedMotion)();

  // This state is used so that we trigger a extra render cycle
  // to animate the child component when it is being unmounted
  const [removeState, setRemove] = (0, _react.useState)(!show);
  (0, _react.useLayoutEffect)(() => {
    const element = containerRef.current;
    if (show) {
      setRemove(false);
      if (!element || preferReducedMotion) return;
      element.animate([from, to], options);
    } else {
      if (!element) return;
      if (preferReducedMotion) {
        setRemove(true);
        return;
      }
      const animation = element.animate(exitAnimation || [to, from], options);
      animation.onfinish = () => {
        setRemove(true);
        // This is important, else the next render cycle due to setRemove will cause flickering effect
        element.style.display = "none";
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, removeState]);
  if (removeState) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef,
    className: className
  }, children);
};
var _default = exports.default = Animate;